import { ApiHeaders } from '@core/core.types';
import { ResultImportFilter } from './result-import.state';

export class ImportResultsAction {
  static type = '[ResultImport] ImportResultsAction';
  constructor(
    public importerVersion: string,
    public files: FileList,
    public signeeId: string
  ) {}
}

export class CheckResultImportSagaState {
  static type = `[ResultImport] CheckResultImportSagaState`;

  constructor(public importId: string) {}
}

export class GetResultImportListAction {
  static type = '[ResultImport] GetResultImportListAction';
  constructor(
    public filters: ResultImportFilter,
    public headers: ApiHeaders,
    public pageToLoad: number,
    public reload: boolean
  ) {}
}

export class GetImportAction {
  static type = '[ResultImport] GetImportAction';
  constructor(
    public importId: string,
    public prependOnPage?: boolean
  ) {}
}

export class ClearErrorsAction {
  static type = '[ResultImport] ClearErrorsAction';
}
